module.exports = __webpack_public_path__ + "img/card_icon_manejo_solicitudes_transferencia_equipos_hover.4bb44cc6.svg";